<div class="w-100 gap-small container">
  <div class="d-flex align-items-center justify-content-center p-small onback-shade-95 radius-medium">
    <img
      [ngClass]="{ disabled: creditStatusEnum() === creditStatus.Closed }"
      src="./wealth-assets/svg/bnpl-icon.svg"
      alt="bnpl"
    />
  </div>

  <div class="d-flex flex-wrap">
    <p
      class="w-100 st-6 text-onback-high is-currency"
      [ngClass]="{ disabled: creditStatusEnum() === creditStatus.Closed }"
    >
      {{ creditAmount() | thousands }} ریال
    </p>
    <div class="mt-tiny">
      <p
        class="w-100 c-2 text-onback-medium"
        [ngClass]="{ disabled: creditStatusEnum() === creditStatus.Closed }"
      >
        اعتبار 4 قسطه
      </p>

      @if (
        creditStatusEnum() === creditStatus.InProgress ||
        creditStatusEnum() === creditStatus.InClosure ||
        creditStatusEnum() === creditStatus.Closed ||
        creditStatusEnum() === creditStatus.Failed
      ) {
        <div class="badge">
          <ngx-badge
            [status]="
              creditStatusEnum() === creditStatus.InProgress ||
              creditStatusEnum() === creditStatus.InClosure ||
              creditStatusEnum() === creditStatus.Closed
                ? 'warning'
                : 'error'
            "
            [mode]="'bold'"
            [size]="'sm'"
          >
            @if (creditStatusEnum() === creditStatus.InProgress) {
              در حال بررسی
            } @else if (creditStatusEnum() === creditStatus.InClosure) {
              در حال بررسی لغو اعتبار
            } @else if (creditStatusEnum() === creditStatus.Closed) {
              لغو شده
            } @else {
              درخواست رد شد
            }
          </ngx-badge>
        </div>
      }
    </div>
  </div>
</div>
